import { Component } from '@angular/core';

@Component({
    selector: 'twitter-icon',
    template: '<img src="/assets/svgs/socials/twitter.svg" height=27 width=27>',
    styleUrls: ['../svg.component.scss']
})
export class TwitterIcon {

}